// extracted by mini-css-extract-plugin
export var blackColor = "#000";
export var greenColor = "#1e8d0b";
export var lightBlackColor = "#444";
export var lightWightColor = "#fdf7f0";
export var pinkColor = "#f4e7e7";
export var redColor = "#f2604d";
export var whiteColor = "#fff";